import { Orientation as n } from "./Orientation.js";
class i {
  static empty() {
    return new i(0, 0, 0, 0);
  }
  x;
  y;
  width;
  height;
  constructor(t, h, e, s) {
    this.x = t, this.y = h, this.width = e, this.height = s;
  }
  static fromElement(t) {
    const { x: h, y: e, width: s, height: r } = t.getBoundingClientRect();
    return new i(h, e, s, r);
  }
  clone() {
    return new i(this.x, this.y, this.width, this.height);
  }
  equals(t) {
    return this.x === t.x && this.y === t.y && this.width === t.width && this.height === t.height;
  }
  getBottom() {
    return this.y + this.height;
  }
  getRight() {
    return this.x + this.width;
  }
  getCenter() {
    return { x: this.x + this.width / 2, y: this.y + this.height / 2 };
  }
  positionElement(t, h) {
    this.styleWithPosition(t.style, h);
  }
  styleWithPosition(t, h = "absolute") {
    return t.left = this.x + "px", t.top = this.y + "px", t.width = Math.max(0, this.width) + "px", t.height = Math.max(0, this.height) + "px", t.position = h, t;
  }
  contains(t, h) {
    return this.x <= t && t <= this.getRight() && this.y <= h && h <= this.getBottom();
  }
  removeInsets(t) {
    return new i(this.x + t.left, this.y + t.top, Math.max(0, this.width - t.left - t.right), Math.max(0, this.height - t.top - t.bottom));
  }
  centerInRect(t) {
    this.x = (t.width - this.width) / 2, this.y = (t.height - this.height) / 2;
  }
  /** @internal */
  _getSize(t) {
    let h = this.width;
    return t === n.VERT && (h = this.height), h;
  }
  toString() {
    return "(Rect: x=" + this.x + ", y=" + this.y + ", width=" + this.width + ", height=" + this.height + ")";
  }
}
export {
  i as Rect
};
//# sourceMappingURL=Rect.js.map
